/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Openusermenu2Inputs */

const en_common_openusermenu2 = /** @type {(inputs: Common_Openusermenu2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open user menu`)
};

/**
* | output |
* | --- |
* | "Open user menu" |
*
* @param {Common_Openusermenu2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_openusermenu2 = /** @type {((inputs?: Common_Openusermenu2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Openusermenu2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_openusermenu2(inputs)
});
export { common_openusermenu2 as "common_openUserMenu" }